export const API_CALL_TYPE = {
  GET_CALL: 'GET',
  POST_CALL: 'POST',
  PUT_CALL: 'PUT',
}

export const getAPIUrl = () => {
  // var API_BASE_URL = "http://localhost:3000";

  // Needs to be moved to .env file.
  // var API_BASE_URL = 'https://dev-api.cma.fluenty.co.za'
  const API_BASE_URL = process.env.REACT_APP_API_URL || ''
  return API_BASE_URL
}

export const getReportRequestData = (
  productId: number,
  identityNumber: string,
) => {
  const body = {
    identityNumber: identityNumber,
    productId: productId,
  }

  return body
}
